export default {
  actionButton: 'Register for a call',
  submitButton: 'Register now',
  oneStepCloser: 'Get one step closer to owning your dream property.',
  themeContentTitle: 'A gallery for living',
  themeContentDesc: 'on Saadiyat Island',
  themeLaunchDesc: '1 to 3-bed apartments in Saadiyat Cultural District',
  welcomeText:
    "Welcome to The Arthouse, where every residence embodies a gallery of creativity and comfort. Step into a distinctive living space designed to capture the energy, connections, and exclusive experiences reminiscent of a private members' club.",
  epicHeading: 'Live in luxury at the epicentre of culture on Saadiyat Island',
  epicContentp1:
    'The Arthouse is the newest treasure in the Saadiyat Cultural District, offering an exclusive residential enclave near iconic landmarks like the Louvre Abu Dhabi, the Natural History Museum, the Guggenheim Abu Dhabi, the Zayed National Museum, teamLab Phenomena, and the Abu Dhabi Performing Arts Centre.',
  epicContentp2:
    'It offers an ideal setting for residents to connect, thrive, and find inspiration.',
  exploreButton: 'Explore the district',
  epicLaunchHeading: 'Live in luxury at the epicentre of culture',
  epicLaunchContent:
    'The Arthouse shines as the newest treasure in the Saadiyat Cultural District. Located near the Louvre Abu Dhabi, the Natural History Museum, the Guggenheim Abu Dhabi, the Zayed National Museum, teamLab Phenomena, and the Abu Dhabi Performing Arts Centre. It is the perfect spot for residents to connect, thrive, and find inspiration.',

  productHeading:
    'Luxury 1 to 3-bedroom apartments and Sky Villas where every detail is curated',
  productContent:
    'Each residence is crafted to inspire creativity and spark engaging conversations. With meticulous attention to detail, from the elegant interiors to the thoughtfully planned communal spaces, The Arthouse is a gallery for living.',

  productButton: 'See floor plans',

  experienceHeading: "The unique energy of an exclusive private members' club",
  experienceContent:
    'The Arthouse is an exclusive community designed to inspire and delight. Enjoy serene moments in lush gardens and relax at the rooftop lounge by the pool. World-class amenities elevate your lifestyle and spark your imagination.',

  serviceHeading: 'Invest in a home today',
  serviceContent:
    'Whether you seek a luxury residence in Saadiyat or a distinguished addition to your real estate portfolio, The Arthouse stands as an exceptional choice.',
  serviceTabOne: 'world-class amenities',
  serviceTabTwo: 'Capital appreciation potential',
  serviceTabThree: 'sought-after location',

  contactHeading: 'Secure your property now',
  contactContent:
    "We are delighted by your interest in The Arthouse. Register to connect with our dedicated sales managers, find out more about The Arthouse in Saadiyat's Cultural District, and receive guidance on securing your dream property.",

  noVideoTagSupport: 'Your browser does not support the video tag.',
  formHeading: 'Be the first to know more',
  formDesc:
    "Register to speak with our dedicated sales managers about The Arthouse, Saadiyat's unique Cultural District, and receive guidance on securing your dream property. ",
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email Address',
  phoneNumber: 'Phone Number',
  reasonToBuy: 'Reason To Buy',
  nationality: 'Nationality',
  residencyStatus: 'Residency Status',
  reasonBuyOptionInvestor: 'Invest',
  reasonBuyOptionHomeOwner: 'Live',
  recieveUpdates:
    'Yes, I would like to receive luxury property listings, bespoke advice, and market trend updates.',
  consentLabel: 'I consent to the',
  consentLabelEnd: 'from Aldar',
  termsAndConditions: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  footerContactTitle: 'Contact us:',
  launchFooterContactTitle: 'SAY HELLO,',
  footerContactCallText: 'CALL',
  footerContactCallNumber: '800 ALDAR',
  footerContactNumber: '+971 2 810 6400',
  footerContactWebsite: 'Aldar.com',
  developedBy: 'Developed by Aldar Properties',
  successHeading: 'Thank you for signing up',
  successContent:
    "Our dedicated sales managers look forward to speaking with you. Please monitor your inbox for exclusive updates. Intrigued by what else Aldar has to offer? Discover other world-class communities within the heart of Abu Dhabi's Cultural District.",
  metaTitle: 'The Arthouse- a gallery for living',
  metaDescription:
    "Discover Aldar's latest project: a members’ club-inspired residence at the epicentre of culture on Saadityat Island in Abu Dhabi.",
  launchWelcomeText:
    "Welcome to The Arthouse, Saadiyat Grove where every home is a gallery of creativity and comfort. Discover a unique living space with the same energy, connections, and experiences as a private members' club.",
  experienceTab1main: 'GRAND HALL',
  experienceTab1sub: 'Expansive, artistic lobby with lush tropical elegance',
  experienceTab2main: 'ART STUDIO',
  experienceTab2sub:
    'Creative hub and invigorating workspace with and art gallery',
  experienceTab3main: 'Residents majlis',
  experienceTab3sub: 'Exclusive modern Arabian private lounge experience',
  experienceTab4main: 'Sky garden',
  experienceTab4sub: 'Rooftop oasis with breath-taking views',
  experienceTab5main: 'Arthouse cinema',
  experienceTab5sub: 'Luxurious independent film screenings for connoisseurs',
  experienceTab6main: 'Entertainment lounge',
  experienceTab6sub: 'Exclusive games room retreat for leisure',
  experienceTab7main: 'Supper club',
  experienceTab7sub: 'Sophisticated social kitchen for memorable gatherings',
  experienceTab8main: 'Health club',
  experienceTab8sub: 'State-of-the-art fitness sanctuary for elite wellness',
  experienceTab9main: 'core studio',
  experienceTab9sub: 'Serene mind-body wellness space for rejuvenation',
  experienceTab10main: 'Tennis court ',
  experienceTab10sub: 'Pristine court for refining athletic prowess',
  experienceTab11main: 'Tropical landscaped garden',
  experienceTab11sub: 'Meticulously curated natural beauty for strolling',
  experienceTab12main: 'Rooftop swimming pool',
  experienceTab12sub: 'Luxurious sky-high aquatic escape with stunning views',
  experienceTab13main: 'Kids playroom',
  experienceTab13sub:
    'An interactive space for children to expand their creativity',
  experienceTab14main: 'Coworking spaces',
  experienceTab14sub:
    'Where design meets productivity and sparks bold conversations',
  contactCommentsPlaceholder: 'Do you have any comments or questions?',
  residencyStatusOptionResident: 'Resident',
  residencyStatusOptionNonResident: 'Non-resident',
  successButton: 'Discover more communities',
  headerActionButton: 'Go to Aldar.com',
};
